export default __webpack_public_path__ + "static/media/stampDuty.f90ffd32.svg";